<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

  <div class="modal-header">
    <h3 class="modal-title font">{{ onlyView ? 'Detalle de consentimiento' : 'Nuevo Consentimiento' }}</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form class="form-search py-3" [formGroup]="formGroup">
      <div class="field">
        <label for="documento">Documento (DNI NFI /NIE)<span class="oblig" *ngIf="!onlyView">*</span></label>
        <div class="d-flex align-items-start gap-2">
          <input id="documento" class="form-control" type="text" formControlName="documento" placeholder="-- Documento --">
          <button type="button" class="btn btn-primary ms-2" (click)="buscarPoseedores()" [disabled]="onlyView">Buscar</button>
        </div>
      </div>

      <div class="field mt-3">
        <label for="poseedores">Razón Social Poseedor - NIMA - Denominación de centro <span class="oblig" *ngIf="!onlyView">*</span></label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <mat-select id="poseedores" formControlName="poseedores" [compareWith]="compareById" placeholder="-- Seleccione poseedores --" multiple>
            <mat-option *ngFor="let poseedor of poseedoresEncontrados" [value]="poseedor">
              {{ getPoseedorLabel(poseedor) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field">
        <label for="codigosLer">Códigos LER <span class="oblig" *ngIf="!onlyView">*</span></label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <mat-select formControlName="codigosLer" id="codigosLer" placeholder="-- Seleccione códigos LER --" multiple>
            <mat-option *ngFor="let ler of codigosLerArray" [value]="ler.id">
              {{ ler.tipoCodigo }} - {{ ler.descripcion }} (Peligroso: {{ ler.peligrosidad ? 'SI' : 'NO' }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="selected-list" *ngIf="(formGroup.get('codigosLer')?.value || []).length">
        <div class="selected-item" *ngFor="let lerId of formGroup.get('codigosLer')?.value">
          <span>
            {{ getLerById(lerId)?.tipoCodigo }} -
            {{ getLerById(lerId)?.descripcion }}
            (Peligroso: {{ getLerById(lerId)?.peligrosidad ? 'SI' : 'NO' }})
          </span>
          <button type="button" class="btn btn-link text-danger" *ngIf="!onlyView && canDeleteCodLer()" (click)="removeCodLer(lerId)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer actions">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="cerrar()">{{ onlyView ? 'Cerrar' : 'Cancelar' }}</button>
      <button type="button" class="btn btn-primary" *ngIf="!onlyView" (click)="guardar()">Guardar</button>
    </div>
  </div>
</div>
